import {
  AffiliationTabs,
  PayoutsStatistics,
} from "features/affiliation/common/types";
import CardWithTitle from "features/affiliation/common/CardWithTitle";
import StatisticItem from "features/affiliation/common/StatisticItem";
import styled from "styled-components";
import Col from "antd/es/col";
import Row from "antd/es/row";
import usePayouts from "features/affiliation/common/hooks/usePayouts";
import Flex from "common/Boxes/Flex";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const OverviewPayoutsStatistics = () => {
  const { getStatisticValue } = usePayouts();
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  return (
    <CardWithTitle
      title={t("payouts.title")}
      relatedTab={AffiliationTabs.PAYOUTS}
    >
      <Row gutter={[16, 16]}>
        {Object.values(PayoutsStatistics).map((title, index) => (
          <Col span={12} key={index}>
            <StatisticWrapper>
              <StatisticItem
                title={t(title)}
                value={getStatisticValue(title) || 0}
              />
            </StatisticWrapper>
          </Col>
        ))}
      </Row>
    </CardWithTitle>
  );
};

export default OverviewPayoutsStatistics;

const StatisticWrapper = styled(Flex)`
  background: ${(p) => p.theme.colors.boxInCardColor};
  padding: 12px 32px;
  border-radius: 4px;
  height: 100%;
`;
